<div [formGroup]="form">
  <input formControlName='email' class="form-control" type="text"/>

  <label>
    <input formControlName='confirm' class="" type="checkbox"/>
    Ich bestätige, dass Abrechnungsbelege (ohne patientenbezogene Daten) an diese E-Mail-Adresse gesendet werden dürfen.
  </label>
</div>
